import { jsx } from "react/jsx-runtime";
import { EditorHeading } from "@contember/ui";
const HeadingRenderer = ({
  attributes,
  element,
  children
}) => (
  // TODO use BlockElement
  /* @__PURE__ */ jsx(EditorHeading, { attributes, level: element.level, align: element.align, isNumbered: element.isNumbered, children })
);
HeadingRenderer.displayName = "HeadingRenderer";
export {
  HeadingRenderer
};
//# sourceMappingURL=HeadingRenderer.js.map
